const MaritalStatusEnum = Object.assign({
  SINGLE: { name: 'Single', value: 'single' },
  MARRIED: { name: 'Married', value: 'married' },
  DIVORCED: { name: 'Divorced', value: 'divorced' },
  CIVIL_PARTNERSHIP: { name: 'Civil partnership', value: 'civil_partnership' },
  WIDOWED: { name: 'Widowed', value: 'widowed' },
});

Object.freeze(MaritalStatusEnum);

function getEnumAsArray() {
  return Object.keys(MaritalStatusEnum)
    .map(key => ({
      name: MaritalStatusEnum[key].name,
      value: MaritalStatusEnum[key].value,
    }));
}

export const maritalStatusArray = getEnumAsArray();

export default MaritalStatusEnum;



// WEBPACK FOOTER //
// ./src/enum/user/MaritalStatus.js